import React, { useEffect, useState } from "react";
import axios from "axios";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import makeStyles from "@mui/styles/makeStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LinearProgress from "@mui/material/LinearProgress";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

const drawerWidth = 300;
const materialTheme = createTheme({
  // set default for now
});
const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  appBarReviewOrder: {
    position: "fixed",
  },
  appBarBottomReviewOrder: {
    top: "auto",
    bottom: 0,
  },
  titleBarReviewOrder: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarTop: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  yellowButton: {
    backgroundColor: "#ffff00",
    color: "black",
    "&:hover": {
      backgroundColor: "#ffff00",
    },
  },
}));

export default function SalesTargets(props) {
  const classes = useStyles();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);

  const [isLoading, setIsLoading] = useState(true);
  const [principals, setPrincipals] = useState([]);
  const [target, setTarget] = useState([]);
  const [, setTargetInputValues] = useState([]);
  const [selectedPrincipal, setSelectedPrincipal] = useState("");
  const [openPrincipalMenu, setOpenPrincipalMenu] = useState(false);

  const menuHandleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    async function fetchData() {
      await loadPrincipals();
      setOpenPrincipalMenu(true);
    }
    fetchData();
  }, []);

  const loadPrincipals = async () => {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/SellerAccounts/getSellerAccountSeller.json",
    };
    await axios(options).then((res) => {
      const isSuccess = res.data.response.is_success;
      if (!isSuccess) {
        alert("Error Encountered");
        return;
      }
      setPrincipals(res.data.response.sellers);
      setIsLoading(false);
    });
  };

  const handleSelectPrincipal = (principal) => {
    setSelectedPrincipal(principal.Companies.name);
    loadTarget(principal.Companies.company_id);
  };

  const loadTarget = async (selectedPrincipal) => {
    setIsLoading(true);
    setOpenPrincipalMenu(false);
    const options = {
      method: "POST",
      url: "/TransactiTargets/getDistributorTargets.json",
      data: objectToFormData({ selectedPrincipal: selectedPrincipal }),
    };
    await axios(options).then((res) => {
      const isSuccess = res.data.response.is_success;
      if (!isSuccess) {
        alert("Error Encountered");
        return;
      }

      const resTarget = res.data.response.target;
      const usersTargets = res.data.response.usersTarget;

      const sortedTargets = Object.keys(resTarget).map((date) => {
        return {
          date,
          value: resTarget[date],
          users_target: usersTargets[date],
        };
      });

      sortedTargets.sort((a, b) => {
        const months = [
          "JANUARY",
          "FEBRUARY",
          "MARCH",
          "APRIL",
          "MAY",
          "JUNE",
          "JULY",
          "AUGUST",
          "SEPTEMBER",
          "OCTOBER",
          "NOVEMBER",
          "DECEMBER",
        ];
        return months.indexOf(a.date) - months.indexOf(b.date);
      });

      console.log(sortedTargets);
      setTarget(sortedTargets);
      setTargetInputValues(sortedTargets);
      setIsLoading(false);
    });
  };

  const SelectPrincipalDialog = () => {
    return (
      <Dialog open={openPrincipalMenu} maxWidth="sm" fullWidth>
        <DialogTitle style={{ fontWeight: "bold", textAlign: "center" }}>
          Select Principal
        </DialogTitle>
        <DialogContent dividers>
          <List>
            {principals.map((value, index) => (
              <ListItem button divider key={value["Companies"]["company_id"]}>
                <ListItemText
                  primary={`${index + 1}. ${value["Companies"]["name"]} (${
                    value["Companies"]["company_id"]
                  })`}
                  onClick={() => handleSelectPrincipal(value)}
                />
              </ListItem>
            ))}
          </List>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "15px",
            }}
          >
            <Button
              variant="contained"
              className={classes.yellowButton}
              onClick={() => {
                setOpenPrincipalMenu(false);
              }}
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());

  return (
    <>
      <CssBaseline />
      {isLoading ? (
        <LinearProgress
          color="secondary"
          style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
        />
      ) : (
        ""
      )}
      <AppBar position="fixed" className={classes.appBarTop}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Sales Targets{" "}
            {selectedPrincipal !== "" ? "(" + selectedPrincipal + ")" : ""}
          </Typography>
          <div style={{ flex: 1 }}></div>
          <IconButton onClick={menuHandleClick}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            open={openMenu}
            anchorEl={menuAnchorEl}
            onClose={() => {
              setMenuAnchorEl(null);
            }}
          >
            <MenuItem
              onClick={() => {
                setOpenPrincipalMenu(true);
                setMenuAnchorEl(null);
              }}
            >
              Select Principal
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <List>
        {target.map((value, index) => (
          <ListItem
            key={index}
            button
            divider
            sx={{ justifyContent: "space-between" }}
          >
            <Typography variant="h6">
              {value.date}
              <Typography
                variant="body2"
                style={{ fontWeight: "bold", marginLeft: "10px" }}
              >
                Principal Target : ₱{value.value}
              </Typography>
              <Typography
                variant="body2"
                style={{ fontWeight: "bold", marginLeft: "10px" }}
              >
                Users Target :{" "}
                {value.users_target >= value.value ? (
                  <span style={{ color: "green", fontWeight: "bold" }}>
                    ₱{value.users_target}
                  </span>
                ) : (
                  <span style={{ color: "red" }}>₱{value.users_target}</span>
                )}
              </Typography>
            </Typography>
          </ListItem>
        ))}
      </List>

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {" "}
          {SelectPrincipalDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
